import { MainState } from './types';

const state: MainState = {
    loading: false
}
export default {
    namespaced: true,
    state,
    mutations: {
        SET_LOADING(state: MainState, loading: boolean) {
            state.loading = loading;
        }
    },
    actions: {
    }
}